
const ContactSection = () => {
  return (
    <section id="contact" className="py-24 bg-white" aria-labelledby="contact-title">
      <div className="max-w-7xl mx-auto px-6">
        <header className="text-center mb-16">
          <h2 id="contact-title" className="text-4xl font-bold text-baby-blue-600 mb-4">
            <a href="#contact" className="hover:text-baby-blue-700 transition-colors">聯絡高雄市前金區日照中心</a>
          </h2>
          <p className="text-gray-600 text-lg">歡迎來電或親臨<strong>前金日間照顧中心</strong>參觀，<strong>高雄市前金日照推薦</strong>首選</p>
        </header>

        <div className="grid lg:grid-cols-2 gap-12">
          <article className="space-y-8">
            <div className="bg-cream-50 rounded-3xl p-8">
              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-baby-blue-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-baby-blue-600" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="font-bold text-baby-blue-600 text-lg mb-2">地址</h3>
                  <address className="not-italic">
                    <p className="text-gray-700">高雄市前金區文武二街163號5樓</p>
                    <p className="text-sm text-gray-500 mt-1">鄰近前金捷運站3號出口，步行約3分鐘</p>
                  </address>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-baby-blue-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-2xl text-baby-blue-600" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="font-bold text-baby-blue-600 text-lg mb-2">電話</h3>
                  <p className="text-gray-700">
                    <a href="tel:07-2416568" className="hover:text-baby-blue-500 transition-colors" title="撥打電話至高雄市前金區日照中心">07-2416568</a>
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="w-12 h-12 bg-baby-blue-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-baby-blue-600" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="font-bold text-baby-blue-600 text-lg mb-2">服務時間</h3>
                  <p className="text-gray-700">週一至週五 08:00-17:00</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-baby-blue-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-baby-blue-600" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="font-bold text-baby-blue-600 text-lg mb-3">服務對象</h3>
                  <div className="flex flex-wrap gap-2">
                    <span className="bg-cream-100 text-baby-blue-600 px-4 py-2 rounded-full text-sm">
                      失智個案
                    </span>
                    <span className="bg-cream-100 text-baby-blue-600 px-4 py-2 rounded-full text-sm">
                      失能個案
                    </span>
                  </div>
                </div>
              </div>

              <div className="flex items-start gap-4 mt-6">
                <div className="w-12 h-12 bg-baby-blue-100 rounded-2xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-facebook-circle-fill text-2xl text-baby-blue-600" aria-hidden="true"></i>
                </div>
                <div>
                  <h3 className="font-bold text-baby-blue-600 text-lg mb-2">粉絲專頁</h3>
                  <a 
                    href="https://www.facebook.com/p/前金社區日間照顧機構-100063908289224/" 
                    target="_blank" 
                    rel="noopener noreferrer nofollow"
                    className="inline-flex items-center gap-2 bg-baby-blue-500 hover:bg-baby-blue-600 text-white px-5 py-2.5 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-facebook-fill" aria-hidden="true"></i>
                    前往 Facebook 粉絲專頁
                  </a>
                  <p className="text-sm text-gray-500 mt-2">追蹤我們獲取最新活動資訊</p>
                </div>
              </div>
            </div>
          </article>

          <div>
            <div className="bg-cream-50 rounded-3xl p-8 h-[500px]">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3682.0!2d120.29!3d22.62!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDM3JzE2LjgiTiAxMjDCsDE3JzI0LjAiRQ!5e0!3m2!1szh-TW!2stw!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0, borderRadius: '1rem' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="高雄市前金區日照中心地圖位置"
                aria-label="前金日間照顧中心 Google 地圖"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
